import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import * as contributorService from './contributor.service';

export const loadContributor = createAsyncThunk( 'contributor/load', async ( userId ) =>
       contributorService.getAllContributor( userId )
);

export const deleteContributor = createAsyncThunk(
       'contributor/delete',
       async ( contributorObject, redirect ) => contributorService.deleteContributor( contributorObject )
);

export const deleteContributorWithoutRedirect = createAsyncThunk(
       'contributor/deleteWithoutRedirect',
       async ( contributorObject, redirect ) => contributorService.deleteContributor( contributorObject )
);

export const contributorSlice = createSlice( {
       name: 'contributor',
       initialState: {
              contributorTab: [],
              contributorGetFromDelete: {},
              isContributorDeleting: false,
              isContributorLoad: false,
              isContributorLoading: false,
              isLoading: false,
              error: '',
              deleteContributorSuccess: false,
       },
       reducers: {
              initContributor: ( state, action ) =>
              {
                     state.contributorTab = [ ...action.payload ];
              },
              initDeleteContributor: ( state, action ) =>
              {
                     state.contributorGetFromDelete = { ...state.contributorGetFromDelete, ...action.payload };
              },
              resetContributorData: ( state ) =>
              {
                     state.isContributorLoad = false;
                     state.isContributorDeleting = false;
                     state.deleteContributorSuccess = false;
                     state.isContributorLoading = false;
                     state.isLoading = false; // Optionnel : réinitialiser l'état de chargement si nécessaire
              },
              resetData: ( state ) =>
              {
                     state.contributorTab = [];
                     state.isContributorLoad = false;
                     state.isContributorLoading = false;
                     state.isLoading = false; // Optionnel : réinitialiser l'état de chargement si nécessaire
              },
              resetDeleteContributorSuccess: ( state ) =>
              {

                     state.isContributorDeleting = false;
                     state.deleteContributorSuccess = false;
              },
       },
       extraReducers: ( builder ) =>
       {
              builder
                     .addCase( loadContributor.pending, ( state ) =>
                     {
                            state.isContributorLoading = true;
                            state.isContributorLoad = false;
                     } )
                     .addCase( loadContributor.fulfilled, ( state, action ) =>
                     {
                            state.isContributorLoading = false;
                            state.isContributorLoad = true;
                            state.contributorTab = [ ...action.payload.data ];
                     } )
                     .addCase( loadContributor.rejected, ( state, action ) =>
                     {
                            state.isContributorLoading = false;
                            state.isContributorLoad = false;
                            state.error = action?.payload?.data ? action.payload.message : action.error.message;
                     } );

              builder
                     .addCase( deleteContributor.pending, ( state ) =>
                     {
                            state.isContributorDeleting = true;
                            state.deleteContributorSuccess = false;
                            // console.log( 'suppression en cour:' );
                     } )
                     .addCase( deleteContributor.fulfilled, ( state, action ) =>
                     {
                            state.isContributorDeleting = false;
                            state.deleteContributorSuccess = true;
                            state.contributorGetFromDelete = {
                                   ...state.contributorGetFromDelete,
                                   ...action.payload,
                            };
                            enqueueSnackbar( 'Intervenant supprimé avec succès !' );
                            // console.log( 'intervenant supprimer avec succès:', action.payload );
                            // redirect();
                     } )
                     .addCase( deleteContributor.rejected, ( state, action ) =>
                     {
                            state.isContributorDeleting = false;
                            state.deleteContributorSuccess = false;
                            state.error = action?.payload?.data ? action.payload.message : action.error.message;
                            // console.log( "Erreur lors de la supression de l'intervenant:", state.error );
                     } );






              builder
                     .addCase( deleteContributorWithoutRedirect.pending, ( state ) =>
                     {
                            state.isContributorDeleting = true;
                            state.deleteContributorSuccess = false;
                            // console.log( 'suppression en cour:' );
                     } )
                     .addCase( deleteContributorWithoutRedirect.fulfilled, ( state, action ) =>
                     {
                            state.isContributorDeleting = false;
                            state.deleteContributorSuccess = true;
                            state.contributorGetFromDelete = {
                                   ...state.contributorGetFromDelete,
                                   ...action.payload,
                            };
                            // console.log( 'intervenant supprimer avec succès:', action.payload );
                            // redirect();
                     } )
                     .addCase( deleteContributorWithoutRedirect.rejected, ( state, action ) =>
                     {
                            state.isContributorDeleting = false;
                            state.deleteContributorSuccess = false;
                            state.error = action?.payload?.data ? action.payload.message : action.error.message;
                            // console.log( "Erreur lors de la supression de l'intervenant:", state.error );
                     } );
       },
} );





const redirect = () =>
{
       enqueueSnackbar( 'Intervenant supprimé avec succès !' );
       setTimeout( () =>
       {
              window.location.href = paths.contributor;
              resetDeleteContributorSuccess();
       }, 50 );
};

export const { initContributor, initDeleteContributor, resetDeleteContributorSuccess, resetContributorData, resetData } =
       contributorSlice.actions;
export default contributorSlice.reducer;
